<div class="db-website" [ngClass]="{'toggled': !!sidebarIsToggled}">
  <div class="db-website__content_wrap">
    <div *ngIf="!hideOptimizerError && !isMobile && website?.domain_hash && optimizerPlugin && !optimizerPlugin.active && _user.subscriptionId === userSubscriptionIds.TRIAL"
         class="optimizer-error">
      <img src="assets/images/icons/info-red.svg" alt="">
      <p><b>{{'text_boosterPluginNotInstalled' | dbText}}</b> {{'text_mandatoryForOptimizedWebsite' | dbText}}</p><a class="db-link" [routerLink]="['move-to-10web']">{{'text_learnMore' | dbText}}</a>
      <i class="db-icon db-icon-popup-close" (click)="hideOptimizerError = true"></i>
    </div>
    <div class="ds-notification-warning"
         *ngIf="!isMobile && website?.domain_hash && !isPHPUpToDate && (routeData.data.pageId !== 'hosting-tools')">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p>
          <span [innerHTML]="'text_phpNeedsToBeUpdated' | dbText"></span><br/>
          <span> Please <a [routerLink]="['hosting/tools']">upgrade your PHP version</a>  to the most recent one available. </span>
        </p>
      </div>
    </div>
    <db-website-title *ngIf="isMobile && routeData.data.pageId !== 'onboarding'
    && routeData.data.pageId !== 'generate-page'
    && routeData.data.pageId !=='onboarding-recreate-website'
    && routeData.data.pageId !=='onboarding-templates'" [website]="website" [sidebarIsToggled]="sidebarIsToggled" (click)="toggleWebsiteSidebar()"></db-website-title>
    <router-outlet></router-outlet>
  </div>

  <db-blocker-screen *ngIf="blockerAction">
    <div>{{'text_maintenanceMode' | dbText}}</div>
    <div>{{blockerAction.title}}</div>
  </db-blocker-screen>
</div>
